var render = function render(){var _vm=this,_c=_vm._self._c;return _c('balance',{ref:"balance",attrs:{"title":_vm.title,"cols":(_vm.isXs)?_vm.mobileCols:_vm.datatableCols,"url":"reports/balance","getAccountLedgerQuery":_vm.getAccountLedgerQuery,"getSubAccountLedgerQuery":_vm.getSubAccountLedgerQuery,"defaultFilters":_vm.defaultFilters,"contrary-to-nature":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }